export default "__VITE_ASSET__24e96762__"